const env = process.env.NODE_ENV || 'development'

const config = {
  development: {
    // 开发环境继续走 vue.config.js 的 /api 代理，避免跨域和后端地址散落在页面中。
    baseURL: 'http://192.168.11.103:16062'
// baseURL: 'https://reportpackback.aojuai.com'
  },
  production: {
    baseURL: 'https://reportpackback.aojuai.com' || '/api'
  }
}
export default config[env] || config.development
